// extracted by mini-css-extract-plugin
export default {"container":"style_container__mMFwz","center":"style_center__lEUIx","card":"style_card__21f-L","title":"style_title__45dI5","description":"style_description__B3HZr"};